/**
 * Custom hook to manage email change logic
 */

import { useState } from 'react';
import { API2_URL } from 'config/constants';
import { request2 } from 'utils/request';

export function useChangeEmail(user, onRequestSuccess) {
  const [show, setShow] = useState(false);
  const [newEmail, setNewEmail] = useState('');
  const [requesting, setRequesting] = useState(false);
  const [error, setError] = useState(null);
  const [mergeAccounts, setMergeAccounts] = useState(false);

  const resetForm = () => {
    setNewEmail('');
    setError(null);
    setMergeAccounts(false);
  };

  const handleShow = () => {
    setShow(true);
    resetForm();
  };

  const handleClose = () => {
    setShow(false);
    resetForm();
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setError(null);
    setRequesting(true);

    try {
      await request2({
        method: 'POST',
        url: `${API2_URL}/user/requestChangeEmail`,
        body: { newEmail, mergeAccounts },
        user,
      });

      setRequesting(false);
      handleClose();
      if (onRequestSuccess) {
        onRequestSuccess(newEmail, mergeAccounts);
      }
    } catch (err) {
      setRequesting(false);
      let errorMessage = err.message || 'Failed to request email change';

      // If there's a response, show status code and body text
      if (err.response) {
        const statusCode = err.response.status;
        let responseText = '';
        try {
          const contentType = err.response.headers.get('Content-Type');
          if (contentType?.includes('application/json')) {
            const json = await err.response.json();
            responseText = JSON.stringify(json, null, 2);
          } else {
            responseText = await err.response.text();
          }
        } catch (parseErr) {
          responseText = 'Unable to parse response';
        }
        errorMessage = `Error ${statusCode}: ${responseText || err.message}`;
      }

      setError(errorMessage);
    }
  };

  const isValidEmail = newEmail && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(newEmail);
  const isEmailAlreadyInUse =
    error && error.toLowerCase().includes('already in use');

  return {
    show,
    newEmail,
    setNewEmail,
    requesting,
    error,
    mergeAccounts,
    setMergeAccounts,
    handleShow,
    handleClose,
    handleSubmit,
    isValidEmail,
    isEmailAlreadyInUse,
  };
}
